let charity_sidebar = ( function( $ ) {

	let $sidebar;

	let _init = function() {
		$sidebar = $( '#charity-sidebar' );

		$sidebar.find( 'a.toggle-link' ).on( 'click', _toggle_panel );
	};

	let _toggle_panel = function( e ) {
		e.preventDefault();

		$( this ).toggleClass( 'open' );
		$( this ).closest( '.contact-details' ).find( '#' + $( this ).data( 'toggle-panel' ) ).slideToggle();
		// $( this ).closest( '.contact-details' ).find( '.toggle-panel' ).slideToggle();
	};

	if ( $( '#charity-sidebar' ).length > 0 ) {
		$( document ).ready( _init );
	}

} )( jQuery );

module.exports = charity_sidebar;